// API Configuration
const API_CONFIG = {
  baseUrl: "http://localhost", // Base URL for the local email service
  port: "3030", // Port for the local email service
  endpoints: {
    sendEmail: "/api/send-email"
  }
};

// Helper function to get full API URL
export const getApiUrl = (endpoint) => {
  // If we have base URL and port, use them, otherwise use relative paths
  const baseWithPort = API_CONFIG.baseUrl ? 
    (API_CONFIG.port ? `${API_CONFIG.baseUrl}:${API_CONFIG.port}` : API_CONFIG.baseUrl) : '';
  
  // If endpoint is already provided, use it directly
  // Otherwise, look it up in the endpoints object
  const path = endpoint.startsWith('/') ? endpoint : API_CONFIG.endpoints[endpoint] || '';
  
  return `${baseWithPort}${path}`;
};

export default API_CONFIG;